var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgR6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.109 5.343v21.442s-.35 5.13 7.666 4.955c0 0 7.21.859 8.118-4.784V13.328s-.558-2.787-5.471-2.787c0 0-3.379-.07-3.552 1l-.035-5.371s1.08-1.205 2.473.035l-.035 3.202h6.62V5.343s0-5.13-7.794-5.13c-7.795 0-7.99 5.13-7.99 5.13zM13.3 17.975v9.843h-.203v.53h.53v.193h1.588v-.215h.212v-5.12s.574-.745 1.903-.58V19.95s1.155-.586 3.295-.586v-2.447s-.795-1.12-2.644.13c0 0-2.111 1.14-2.557-.14h-1.743v.171h-.391v.362h-.19v.4h.193l.007.135zm2.294 2.93v1.505h1.556v-2.086l-.218-.377h-.36l.01.355s.37.064.414.292l-.138.13c.003-.003-.395-.593-1.264.18z",
  fill: "#0CA5FF"
})));
export default SvgR6;